/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

/**
 * Sort direction
 */
export type SortItemDtoOrder = typeof SortItemDtoOrder[keyof typeof SortItemDtoOrder];


export const SortItemDtoOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;
